export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=405f16233f7815c9b5874294551c0b0fe39550e9c8&name=revalidateCommunity!'